import { LocationItem, Menu, MerchantItem } from '../../interface';

export function isTopLevelItem(element: Menu<MerchantItem | LocationItem> | MerchantItem | LocationItem): element is MerchantItem | LocationItem {
  return !Object.hasOwn(element, 'categoryName');
}
